export default "__VITE_ASSET__C2njZ_o9__"